import {
  GoabBlock,
  GoabContainer,
  GoabFormItem,
  GoabRadioGroup,
  GoabRadioItem,
  GoabSpacer,
} from "@abgov/react-components";

import { ETransferPaymentInfo, InPersonPayment } from "./components";
import { useGenerationForm } from "../../../hooks";

export const PaymentInfoSection = () => {
  const {
    form,
    fieldValues,
    fieldErrors,
    fieldTouches,
    handleChange,
    verificationState,
  } = useGenerationForm("PaymentInformation");

  const receivePaymentError =
    fieldTouches.streetAddressLine1 && fieldErrors.streetAddressLine1;

  return (
    <>
      {/*This section only shows if "verified" or "pending" status is selected*/}
      <GoabContainer accent="thin">
        <h3>Confirm your payment information</h3>
        <GoabBlock direction="column" gap="xs">
          <GoabFormItem
            label="How would you like to receive your payment, if eligible?"
            error={fieldErrors.receivePayment}
          >
            <GoabRadioGroup
              name="receivePayment"
              onChange={({name, value}) => {
                handleChange(name, value);
                // Needed for radio buttons
                setTimeout(() => form.validateForm());
              }}
              orientation="vertical"
              value={fieldValues.receivePayment}
              error={!!receivePaymentError}
            >
              <GoabRadioItem
                value="e-transfer"
                label="e-Transfer payment"
              ></GoabRadioItem>
              <GoabRadioItem
                value="in-person"
                label={
                  verificationState.verificationStatus === 4
                    ? "Prepaid card"
                    : "Visit Alberta Supports Centre in-person for payment"
                }
              ></GoabRadioItem>
            </GoabRadioGroup>
          </GoabFormItem>
          <GoabSpacer vSpacing="xs"></GoabSpacer>
          {fieldValues.receivePayment === "e-transfer" && (
            <ETransferPaymentInfo />
          )}
          {fieldValues.receivePayment === "in-person" &&
            verificationState.verificationStatus !== 4 && <InPersonPayment />}
        </GoabBlock>
      </GoabContainer>
    </>
  );
};
